import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import { BRANDS, browser } from '../../../common';
import { brandContext } from '../../../store/brandContext';
import { ZenitLogo } from './-ZenitLogo';
import { ZenbetLogo } from './-ZenbetLogo';
import { CupisLogo } from './-CupisLogo';
import { LogoNameOnly } from './-LogoNameOnly';
import { throwParamsToLink } from '../../../helpers';
// import {useLogForClickLogo} from "../../../helpers/customHooks";
import { logForClickLogo } from '../../../logger';
import { CupisNewYearLogo } from './-NewYearLogo/-CupisNewYearLogo';
import { ZenitNewYearLogo } from './-NewYearLogo/-ZenitNewYearLogo';
import { BetonMobile } from './betonMobile/index';

const Logo = inject(
  'appStore',
  'kafkaStore',
)(
  observer((props) => {
    const {
      kafkaStore: { imprintHash },
      isLogoNameOnly,
      isNewYear,
      isBeton,
    } = props;
    const brandName = useContext(brandContext);
    const [link, setLink] = useState('');
    const classes = classNames('site-logo');
    const [brandLogo, setBrandLogo] = useState(null);

    const onLogoClick = () => {
      logForClickLogo(imprintHash);
    };

    useEffect(() => {
      setLink(browser().mobile ? `/m${props.link}` : props.link);
    }, [link]);

    useEffect(() => {
      if (isLogoNameOnly) {
        switch (brandName) {
          case BRANDS.zenbet:
            setBrandLogo(<LogoNameOnly />);
            break;
          case BRANDS.zenit:
            setBrandLogo(<LogoNameOnly />);
            break;
          case BRANDS.cupis:
            setBrandLogo(<LogoNameOnly />);
            break;
        }
      } else if (isNewYear) {
        switch (brandName) {
          case BRANDS.zenit:
            setBrandLogo(<ZenitNewYearLogo />);
            break;
          case BRANDS.cupis:
            setBrandLogo(<CupisNewYearLogo />);
            break;
        }
      } else if (isBeton) {
        switch (brandName) {
          case BRANDS.cupis:
            setBrandLogo(<BetonMobile />);
            break;
        }
      } else {
        switch (brandName) {
          case BRANDS.zenbet:
            setBrandLogo(<ZenbetLogo />);
            break;
          case BRANDS.zenit:
            setBrandLogo(<ZenitLogo />);
            break;
          case BRANDS.cupis:
            setBrandLogo(<CupisLogo />);
            break;
        }
      }
    }, []);
    return (
      <a
        onClick={onLogoClick}
        href={link + throwParamsToLink()}
        className={classes}
        style={{ display: 'inline-block' }}
      >
        {brandLogo}
      </a>
    );
  }),
);

Logo.propTypes = {
  link: PropTypes.string,
};

Logo.defaultProps = {
  link: '/',
};

export default Logo;
